import { TextField, Select, InputLabel, withStyles } from "@material-ui/core";

export const CssTextField = withStyles({
	root: {
		"& label.Mui-focused": {
			color: "white",
		},
		"& .MuiFormLabel-root": {
			color: "white",
		},
		"& .MuiInput-underline:after": {
			borderBottomColor: "white",
		},
		"& .MuiOutlinedInput-input": {
			color: "white",
			fontWeight: 800,
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				borderColor: "white",
			},
			"&:hover fieldset": {
				borderColor: "white",
			},
			"&.Mui-focused fieldset": {
				borderColor: "white",
			},
		},
	},
})(TextField);

export const CssSelect = withStyles({
	root: {
		"& .MuiInputBase-input": {
			color: "white",
		},
		"& .MuiInput-underline:before": {
			borderBottomColor: "white",
		},
		"& .MuiInput-underline:after": {
			borderBottomColor: "white",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			borderBottomColor: "white",
		},
	},
	icon: {
		fill: "white",
	},
})(Select);

export const CssLabel = withStyles({
	root: {
		color: "white",
		"&.Mui-focused": {
			color: "white",
		},
	},
})(InputLabel);
